export enum LoginEduEnabledForm {
    both = 'both',
    register = 'register',
    login = 'login',
}
